export default {"src":"/_next/static/media/BrightId-logo.4c6ed941.svg","height":500,"width":1024,"blurWidth":0,"blurHeight":0};